<template>
    <div>
          <!-- 面包屑导航 -->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item @click.native="gohome" ><a>首页</a></el-breadcrumb-item>
            <el-breadcrumb-item>保险理赔流程</el-breadcrumb-item>
          </el-breadcrumb>


          <el-card class="box-card">
           <div slot="header" class="clearfix">
                <span style="font-size: 28px;font-weight: 500;">保险理赔流程</span>
            </div>
            <!-- <span>1、保险理赔更改为保险理赔提供如下材料</span>
             <el-divider></el-divider>

            <span>2、工残第2项更改为工伤保险费无欠缴证明（需到所在申报区社保补充工伤窗口办理）</span>
                <el-divider></el-divider>

            <span>3、工残第7项更改为账户复印件或银行卡复印件。（银行卡可提供中行、农行、建行、工行、邮政）</span>
                <el-divider></el-divider>
            <span>4、工亡第2项更改为工伤保险费无欠缴证明（需到所在申报区社保补充工伤窗口办理）</span>
                    <el-divider></el-divider>
            <span>5、工亡第6项更改为账户复印件或银行卡复印件，（银行卡可提供中行、农行、建行、工行、邮政）</span>
                <el-divider></el-divider>
            <span>6、工残每5、6、8项把原件已核、签名、日期删除</span>
             <el-divider></el-divider>

            <span>7、工亡第4、5项把原件已核、签名、日期删除</span>
                <el-divider></el-divider>

            <span>8、备注第4项更改为：工亡涉及死亡证明、户口注销证明、殡葬证明提供不了原件的，客户需提供原件到我公司办理，待审核后留存复印件即可。</span>
                <el-divider></el-divider>
            <span>9、备注增加第6项，理赔申请书、自然人登记表、授权委托书、权益转让书需到所在区社保申报补充工伤窗口领取。</span> -->
                    <!-- <el-divider></el-divider> -->
            <!-- <span>10.出院记录或出院小结（盖红章）</span>
                    <el-divider></el-divider>
            <span>11.理赔金打入单位账户的提供非自然人登记表一套（营业执照、法人身份证、经办人身份证）盖公章</span>
                <el-divider></el-divider>
            <span>12.非本人办理的需填写理赔授权委托书</span>
             <el-divider></el-divider>

            <span>13.理赔金打入单位账户或非本人账户的需填写保险赔款权益转让书（如是单位盖公章、本人按手印，如是其他受益人签名按手印）</span>
                <el-divider></el-divider>

            <span>14.自然人登记表</span>
                <el-divider></el-divider>
            <span style="font-weight: 400;font-size: 24px;">工亡</span>
                <el-divider></el-divider>
            <span>1.工伤决定认定书（红章）</span>
                <el-divider></el-divider>
            <span>2.工伤保险无欠缴证明（社保养老红章）</span>
             <el-divider></el-divider>
            <span>3.交通事故认定书 </span>
             <el-divider></el-divider>
            <span>4.被保险人身份证件2份（原件已核、签名、日期）</span>
             <el-divider></el-divider>
            <span>5.经办人证件（原件已核、签名、日期）</span>
             <el-divider></el-divider>
            <span>6.帐户复印件（原件已核、签名、日期）</span>
             <el-divider></el-divider>
            <span>7.被保险人死亡医学证明、户口注销证明、殡葬证明原件</span>
             <el-divider></el-divider>
            <span>8.理赔申请书</span>
             <el-divider></el-divider>
            <span>9.理赔金打入单位账户的提供非自然人登记表一套（营业执照、法人身份证、经办人身份证）盖公章</span>
             <el-divider></el-divider>
            <span>10.非本人办理的需填写理赔授权委托书</span>
             <el-divider></el-divider>
            <span>11.理赔金打入单位账户或非本人账户的需填写保险赔款权益转让书（如是单位盖公章、如是其他受益人签名按手印）</span>
             <el-divider></el-divider>
            <span>12.自然人登记表</span>
             <el-divider></el-divider>
            <span>备注： </span>
             <el-divider></el-divider>
            <span style="display:block;text-indent:2em;">1、身份证件及账号复印件需要原件已核、已核人员签名及日期。</span>
             <el-divider></el-divider>
            <span style="display:block;text-indent:2em;">2、理赔申请书必须填写完整。（日期不写）</span>
             <el-divider></el-divider>
            <span style="display:block;text-indent:2em;">3、工伤认定书、伤残鉴定书、无欠缴证明等材料单位名头必须一致，均为投保时单位名称，如有特殊情况，请单位开具情况说明并盖公章。</span>
             <el-divider></el-divider>
            <span style="display:block;text-indent:2em;">4、工亡涉及死亡证明、户口注销证明、殡葬证明提供不了原件的，客户可把原件拿到公司让我公司看到原件后留下复印件即可，由本公司人员写上原件已核。</span>
             <el-divider></el-divider>
            <span style="display:block;text-indent:2em;">5、理赔金转让给其他受益人的需提供其他全部法定继承人（父母、配偶、子女）的关系证明和身份证复印件或公证书</span>
             <el-divider></el-divider>
             <span style="font-weight: 400;font-size: 24px;">企补所需理赔材料</span>
             <el-divider></el-divider>
             <span>1.被保险人身份证、银行卡原件及复印件正反面</span>
                <el-divider></el-divider>
            <span>2.盘锦市城镇职工基本医疗保险定点医疗机构的住院结算发票原件</span>
             <el-divider></el-divider>
            <span>3.盘锦市城镇职工基本医疗保险定点医疗机构出具的出院记录</span>
             <el-divider></el-divider>
            <span>4.理赔电话2858666</span>
             <el-divider></el-divider>
            <span>5.报销地址辽宁省盘锦市文圣区河东新城路财富中心A座16-37 中国人民健康保险公司</span> -->
          </el-card>


    </div>


</template>
<script>
    export default {
        methods: {
            //返回首页
            gohome() {
                window.sessionStorage.setItem('activePath', "/welcome");
                this.$router.push("/welcome");
                this.reload();
            }
        }
    }
</script>
<style lang="less" scoped>
    .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 12px 0;
    }
</style>
